import { Box, Container } from "@mui/material";
import React from "react";
import Styles from "./LoadingScreen.module.scss";
import PropTypes from "prop-types";
import AshokaChakra from "../../../../assets/svgs/ashoka-chakra.svg";

function LoadingScreen({ containedMode = false }) {
  return (
    <Container
      maxWidth={false}
      sx={{ height: containedMode ? "100%" : "100vh" }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }} // Ensure Box also takes full height of its parent
      >
        <Box
          sx={{
            height: "80px",
            width: "80px",
            backgroundImage: `url(${AshokaChakra})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            mb: "20px",
          }}
          className={Styles.loader}
        />
        {/* <div className={Styles.loader} style={{ marginBottom: "20px" }}></div> */}
        Loading...
      </Box>
    </Container>
  );
}

LoadingScreen.propTypes = {
  containedMode: PropTypes.bool,
};

export default LoadingScreen;
